import { apiUrl } from "../config/config";

export const DESIGN_NOW_FALLBACK_URL =
  "/designer?id=150&pid=5151&colorId=701426";

const DESIGN_NOW_API_URL = `${apiUrl}/api/design-now`;

const cleanDesignNowUrl = (value) => {
  if (!value || typeof value !== "string") return "";

  let url = value.trim();
  const markdownUrlMatch = url.match(/\[[^\]]+\]\(([^)]+)\)/);

  if (markdownUrlMatch?.[1]) {
    url = markdownUrlMatch[1].trim();
  }

  return url.replace(/\\&/g, "&").replace(/&amp;/g, "&");
};

const getUrlFromResponse = (data) => {
  const firstItem = Array.isArray(data)
    ? data[0]
    : Array.isArray(data?.data)
      ? data.data[0]
      : data?.data || data;

  return cleanDesignNowUrl(firstItem?.url || firstItem);
};

const toDesignNowPath = (value) => {
  const url = cleanDesignNowUrl(value);
  if (!/^https?:\/\//i.test(url) && !url.startsWith("/")) return "";

  try {
    const { pathname, search, hash } = new URL(url, "https://inkofly.com");
    return `${pathname}${search}${hash}`;
  } catch {
    return "";
  }
};

export const getDesignNowUrl = async (
  fallbackUrl = DESIGN_NOW_FALLBACK_URL
) => {
  const fallbackPath = toDesignNowPath(fallbackUrl) || DESIGN_NOW_FALLBACK_URL;

  try {
    const response = await fetch(DESIGN_NOW_API_URL);

    if (!response.ok) {
      throw new Error(`Design now API failed: ${response.status}`);
    }

    const data = await response.json();
    const designNowPath = toDesignNowPath(getUrlFromResponse(data));

    return designNowPath || fallbackPath;
  } catch (error) {
    console.error("Error fetching Design Now URL:", error);
    return fallbackPath;
  }
};
